export const Rating = ({ rating }: { rating: number | null }) => {
  if (rating === null) return null;
  return (
    <div className="text-warning whitespace-nowrap" title={`${rating}/5`}>
      {"★".repeat(rating)}
      <span className="text-grey-200">{"★".repeat(5 - rating)}</span>
    </div>
  );
};
